import React from 'react';
import { PropTypes } from 'prop-types';

import { Field } from '@ontruck/orc';

const Input = ({
  onChange,
  name,
  t,
  isFullWidth,
  asideRightText,
  error,
  defaultValue,
}) => (
  <Field
    id={name}
    type="text"
    name={name}
    onChange={onChange}
    label={t(`PaymentMethodSelector.fields.${name}`)}
    fullWidth={isFullWidth}
    asideRightText={asideRightText}
    error={error}
    defaultValue={defaultValue}
  />
);

Input.propTypes = {
  t: PropTypes.func,
  onChange: PropTypes.func,
  name: PropTypes.string,
  isFullWidth: PropTypes.bool,
  asideRightText: PropTypes.bool,
  error: PropTypes.bool,
  defaultValue: PropTypes.string,
};

Input.defaultProps = {
  t: (t) => t,
  name: '',
  onChange: () => ({}),
  isFullWidth: false,
  asideRightText: false,
  error: false,
  defaultValue: '',
};

export default Input;
